<template>
  <div :class="$style.raiders">
    <main>
      <div :class="$style.classify">
        <h1>
          <img :src="tabType === 'messages' ? `${$cdnLink}/suspend/qingbao/icon.png` : `${$cdnLink}/suspend/qingbao/icon1.png`" alt="" />
          <span>{{ title }}</span>
        </h1>
        <ul>
          <li
            v-for="item in menu_list"
            :key="item.menu_id"
            :class="[item.menu_id === active_menu.menu_id ? $style.active : '']"
            @click="setActiveMenu(item)"
          >
            <span :class="item.hint ? $style.hint : ''">{{ item.name }}</span>
          </li>
        </ul>
        <i :class="[$style.close, 'iconfont', 'yw-guanbi1']" @click="close"></i>
      </div>
      <div :class="$style.content">
        <ul :class="$style.articleTitle">
          <li
            v-for="item in article_list"
            :key="item.article_id"
            :class="[
              active_article.article_id === item.article_id ? $style.active : '',
              item.article_id === adjoin_menu[0] ? $style.activeLast : '',
              item.article_id === adjoin_menu[1] ? $style.activeNext : '',
            ]"
            @click="setActiveArticle(item)"
          >
            <div :class="item.hint ? $style.hint : ''">
              <img
                :src="
                  active_article.article_id === item.article_id
                    ? `${$cdnLink}/suspend/qingbao/sanjiao1.png?v=1`
                    : `${$cdnLink}/suspend/qingbao/sanjiao3.png?v=1`
                "
                alt=""
                :class="$style.icon"
              />
              <span>{{ item.name }}</span>
            </div>
          </li>
          <div v-if="active_menu.jump_mode != 0" :class="[adjoin_menu[1] === -1 ? $style.activeNext : '', $style.more]" @click="readMore">
            <span>了解更多</span>
            <img :src="`${$cdnLink}/suspend/qingbao/xiangyou.png`" alt />
          </div>
        </ul>
        <!-- 文章类型为文本并且菜单不为空时候展示 -->
        <div :class="$style.articleText" v-if="!is_empty && article_info.type === 2">
          <div v-html="article_info.article" :class="$style.textContent" ref="textArticleEl"></div>
        </div>
        <div :class="$style.articleText" v-if="!is_empty && article_info.type === 1">
          <div v-if="article_info.show_type === 2" :class="$style.jumpMode" @click="readMore">
            <span>查看更多</span>
            <img :src="`${$cdnLink}/suspend/qingbao/xiangyou.png`" alt="" />
          </div>
          <iframe :src="article_info.article" :class="$style.linkFrame"></iframe>
        </div>
        <!-- 没活动情况 -->
        <div :class="$style.articleEmpty" v-if="is_empty">
          <img :src="`${$cdnLink}/suspend/qingbao/empty.png`" alt="" />
          <p>
            快去<span>【{{ account_name }}】</span>获取更多信息吧
          </p>
          <p>公众号账号：{{ account_id }}</p>
          <Button class="btn" :data-clipboard-text="account_id" @click="burnReport">一键复制打开微信领取</Button>
        </div>
      </div>
    </main>
    <Popup v-if="popupVisible" :type="tabType" :account="account_name" :accountId="account_id" text="获取更多攻略资讯" @close="popupVisible = false"></Popup>
    <FullScreenView v-if="fullScreenShow" @close="fullScreenShow=false" :link="fullScreenLink"></FullScreenView>
    <BoxDownLoad v-if="boxDownLoadShow" @close="boxDownLoadShow=false" type="wx"></BoxDownLoad>
  </div>
</template>

<script>
import { Button } from 'vant';
import Clipboard from 'clipboard';
import Popup from '../common/Popup.vue';
import { mapState } from 'vuex';
import { notifyRemindReadArticleId, gameOpenDownloads } from '@/bridge/AppJsBridge';
import { articleApi } from '@/api/suspend.js';
import _ from 'lodash';
import { handleTextArticle } from '@/libs/business/suspend';
import FullScreenView from '@/components/FullScreenView.vue'
import { buryReport } from '@/libs/business/account'
import BoxDownLoad from '../common/boxDownload.vue';
import { generJumpLink } from '@/libs/business/box'

export default {
  name: '',
  props: ['tabType'],
  components: {
    Button,
    Popup,
    FullScreenView,
    BoxDownLoad
  },
  data() {
    return {
      active_menu: {},
      article_list: [],
      active_article: {},
      article_info: {},
      popupVisible: false,
      fullScreenShow: false,
      fullScreenLink: "",
      boxDownLoadShow: false
    };
  },
  async mounted() {
    this.copyInit();
    this.$nextTick(() => {
      this._initActiveArticle();
    });
  },
  computed: {
    ...mapState({
      account_name: (state) => state.suspend.account_name,
      account_id: (state) => state.suspend.account_id,
      raidersList: (state) => state.suspend.raidersList,
      messagesList: (state) => state.suspend.messagesList,
    }),
    menu_list() {
      return this.tabType === 'messages' ? this.messagesList : this.raidersList;
    },
    is_empty() {
      return !this.menu_list.length || !this.article_list.length;
    },
    title() {
      return this.tabType === 'messages' ? '情报' : '攻略';
    },
    adjoin_menu() {
      const activeIndex = this.article_list.findIndex((item) => item.article_id === this.active_article.article_id);
      if (activeIndex === -1) return [];
      if (activeIndex === 0) {
        if (activeIndex === this.article_list.length - 1) return [-1, -1];
        return [-1, this.article_list[activeIndex + 1].article_id];
      } else if (activeIndex === this.article_list.length - 1) {
        return [this.article_list[activeIndex - 1].article_id, -1];
      } else {
        return [this.article_list[activeIndex - 1].article_id, this.article_list[activeIndex + 1].article_id];
      }
    },
  },
  methods: {
    clearCache() {
      this.$setStorage('messages_hint_list', '');
    },
    // 初始化显示的文章
    async _initActiveArticle() {
      const { redirectArticle } = this.$store.state.suspend;
      if (!redirectArticle) {
        // 非强提醒和首页跳转进来情况
        this.active_menu = this.menu_list[0];
        if (this.active_menu) {
          this.article_list = this.active_menu.article_list || [];
          this.active_article = this.article_list[0];
          this.setCache();
          this.getArticleText();
        }
      } else {
        // 强提醒或首页跳转进来情况
        this.active_menu = this.menu_list.find((item) => item.menu_id == redirectArticle.menu_id);
        if (this.active_menu) {
          this.article_list = this.menu_list.find((item) => item.menu_id == redirectArticle.menu_id).article_list || [];
          this.active_article = this.article_list.find((item) => item.article_id == redirectArticle.article_id);
          this.setCache();
          this.getArticleText();
          this.$store.commit('suspend/CHANGE_STATE', { redirectArticle: null });
        } else {
          this.active_menu = {}
        }
      }
    },
    async readMore() {
      if (this.active_menu.jump_mode == 3) {
        const gameUrl = await generJumpLink()
        gameOpenDownloads({
          gameUrl: gameUrl.wxBoxForumUrl
        })
        this.boxDownLoadShow = true;
      }
      if (this.active_menu.jump_mode === 1) {
        this.popupVisible = true;
      }
      this.article_info.show_type = 1;
    },
    async setActiveMenu(menu) {
      this.active_menu = this.menu_list.find((item) => item.menu_id === menu.menu_id);
      this.article_list = this.active_menu.article_list || [];
      this.active_article = this.article_list[0];
      this.setCache();
      this.getArticleText();
    },
    setActiveArticle(article) {
      this.active_article = article;
      this.setCache();
      this.getArticleText();
    },
    async getArticleText() {
      if (this.active_article) {
        const r = await articleApi({ article_id: this.active_article.article_id });
        this.article_info = r.content;
        if (this.article_info.type === 2) {
          this.article_info.article = handleTextArticle(this.article_info.article)
        }
        setTimeout(() => {
          this.handleTextLinkClick();
        }, 200);
        notifyRemindReadArticleId(this.active_article.article_id)
      }
    },
    handleTextLinkClick() {
      const textArticleEl = this.$refs.textArticleEl;
      if (textArticleEl) {
        const aEl = textArticleEl.getElementsByTagName('a');
        for ( let i =0; i < aEl.length; i++ ) {
          aEl[i].addEventListener('click', (e) => {
            this.fullScreenLink = aEl[i].dataset.href;
            this.fullScreenShow = true;
          })
        }
      }
    },
    close() {
      this.$emit('showSideWindow');
    },
    burnReport() {
      buryReport(this.tabType === 'messages' ? 'MESSAGE_CLICK_COPY' : 'STRATEGY_CLICK_COPY')
    },
    copyInit() {
      this.clipboard = new Clipboard('.btn');
      this.clipboard.on('success', () => {
        this.$toast({
          message: '复制成功',
          position: 'bottom',
        });
        gameOpenDownloads({
          gameUrl: 'weixin://',
        });
      });
    },
    setCache() {
      if (this.tabType !== 'messages') return;
      this.$store.commit('suspend/SET_MESSAGES_CACHE', {
        menu_id: this.active_menu.menu_id,
        article_id: this.active_article ? this.active_article.article_id : '',
      });
    },
  },
  beforeDestroy() {
    this.clipboard && this.clipboard.destroy();
  },
};
</script>

<style lang="scss" module>
@import '~@/assets/css/utils.scss';

.raiders {
  position: fixed;
  width: 100%;
  height: 100%;
  > main {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 487px;
    height: 330px;
    border-radius: 13px;
    overflow: hidden;
    .content {
      background: #f9eff2;
      border-bottom-left-radius: 13px;
      border-bottom-right-radius: 13px;
      display: flex;
      height: 100%;
      padding-left: 135px;
      .articleTitle {
        position: absolute;
        left: 0;
        display: flex;
        flex-direction: column;
        width: 145px;
        height: 275px;
        overflow: auto;
        font-size: 13px;
        overflow-x: auto;
        justify-content: flex-start;
        margin: 8px 0;
        > li {
          flex: none;
          color: #8b8b8b;
          position: relative;
          display: flex;
          align-items: center;
          height: 40px;
          margin-left: 10px;
          border-bottom-left-radius: 40px;
          border-top-left-radius: 40px;
          padding-left: 14px;
          > div {
            display: flex;
            &.hint {
              position: relative;
              &:before {
                position: absolute;
                content: ' ';
                top: 4px;
                left: -8px;
                width: 3px;
                height: 3px;
                border-radius: 50%;
                background: #da3c22;
              }
            }
            > span {
              max-width: 80px;
            }
            .icon {
              height: 10px;
              margin-right: 8px;
            }
          }
          &.active {
            background: #ffffff;
            color: #ff5955;
          }
        }
        .more {
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ff5b58;
          height: 40px;
          > img {
            height: 12px;
            margin-left: 5px;
          }
        }
        .activeLast {
          position: relative;
          &:before {
            position: absolute;
            content: ' ';
            width: 8px;
            height: 8px;
            background: #ffffff;
            right: 10px;
            bottom: 0px;
          }
          &:after {
            position: absolute;
            content: ' ';
            width: 16px;
            height: 16px;
            border-radius: 24px;
            background: #f9eff2;
            right: 10px;
            bottom: 0px;
            z-index: 1;
          }
        }
        .activeNext {
          position: relative;
          &:before {
            position: absolute;
            content: ' ';
            width: 8px;
            height: 8px;
            background: #ffffff;
            right: 10px;
            top: 0px;
          }
          &:after {
            position: absolute;
            content: ' ';
            width: 16px;
            height: 16px;
            border-radius: 24px;
            background: #f9eff2;
            right: 10px;
            top: 0px;
            z-index: 1;
          }
        }
      }
      .articleText {
        background-color: #ffffff;
        width: 345px;
        height: 275px;
        border-radius: 11px;
        border-top-left-radius: 0;
        font-size: 12px;
        padding: 10px;
        margin-top: 8px;
        overflow-y: auto;
        position: relative;
        .jumpMode {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.5) 70%,
            rgba(255, 255, 255, 0.9) 90%,
            rgba(255, 255, 255, 1) 100%
          );
          display: flex;
          justify-content: center;
          align-items: flex-end;
          > span {
            font-size: 10px;
            color: #ff5b58;
            line-height: 30px;
          }
          > img {
            display: inline-block;
            width: 10px;
            height: 10px;
            margin-bottom: 10px;
            margin-left: 3px;
          }
        }
        .textContent {
          width: 100%;
          height: 100%;
          line-height: 1.2;
          a {
            color: #ff5b58;
          }
          img {
            max-width: 100%;
          }
        }
        .linkFrame {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
        }
      }
      .articleEmpty {
        @extend .articleText;
        text-align: center;
        padding-top: 41px;
        > img {
          display: inline-block;
          width: 85px;
          margin-bottom: 15px;
        }
        > p {
          color: #7a7979;
          margin-bottom: 5px;
          > span {
            color: #ff5955;
          }
        }
        > button {
          width: 146px;
          height: 24px;
          background: #ff5b58;
          border-radius: 12px;
          color: #ffffff;
          border: none;
          font-size: 11px;
        }
      }
    }
    .classify {
      background: #ff5955;
      color: #ffffff;
      font-size: 0;
      text-align: center;
      display: flex;
      height: 40px;
      align-items: center;
      > h1 {
        font-size: 16px;
        width: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        > img {
          height: 16px;
          margin-right: 4px;
        }
      }
      > ul {
        font-size: 14px;
        height: 100%;
        width: calc(100% - 120px);
        overflow-x: auto;
        text-align: left;
        display: flex;
        > li {
          flex: none;
          position: relative;
          height: 100%;
          display: inline-block;
          line-height: 40px;
          min-width: 50px;
          margin: 0 10px;
          text-align: center;
          .hint {
            position: relative;
            &:before {
              position: absolute;
              content: ' ';
              top: -2px;
              right: -8px;
              width: 3px;
              height: 3px;
              border-radius: 50%;
              background: #ffffff;
            }
          }
          &.active {
            &::before {
              position: absolute;
              content: ' ';
              bottom: 0;
              left: 0;
              width: 100%;
              height: 2px;
              background: #ffffff;
            }
          }
        }
      }
      .close {
        width: 40px;
      }
    }
  }
}
</style>
